import React, { useMemo } from 'react'
import { userBusinessesApi } from '@disco/state-management/ducks/businesses'
import { Box, Text } from 'components/ds'
import { SwitcherPopoverContentLink } from './switcher-popover-content-link'
import { SwitcherPopoverAvatar } from './switcher-popover-avatar'
import { useSelector } from 'react-redux'
import { getUser } from '@disco/state-management/selectors/user'

export function SwitcherPopoverContentBusinesses() {
  const user = useSelector(getUser)
  const userBusinesses = userBusinessesApi.useGetUserBusinessesQuery()

  const userBusinessesWithoutCurrentBusiness = useMemo(() => {
    if (!user.business || !userBusinesses.data || userBusinesses.error) {
      return []
    }

    return userBusinesses.data
      .filter(business => business.id !== user.business.id)
      .slice(0, 500)
      .sort((a, b) => {
        if (a.name === b.name) {
          return 0
        }
        return a.name > b.name ? 1 : -1
      })
  }, [user, userBusinesses])

  if (!userBusinessesWithoutCurrentBusiness.length) {
    return null
  }

  return (
    <Box maxHeight={`${52 * 6}px`} overflow="auto">
      <Box px="4">
        <Text size="1" color="gray">
          OTHER DISCOS
        </Text>
      </Box>
      {userBusinessesWithoutCurrentBusiness.map(business => (
        <SwitcherPopoverContentLink
          title={business.name}
          subtitle={business.hostname}
          leftNode={
            <SwitcherPopoverAvatar
              name={business.name}
              imageUrl={business.image}
            />
          }
          href={`https://${business.hostname}`}
          key={business.id}
          isExternal
        />
      ))}
    </Box>
  )
}
